"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.PasswordUI = void 0;
var react_1 = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var Buttons = __importStar(require("../../button"));
var Form = __importStar(require("../../form"));
var LibUtils = __importStar(require("../../../utils"));
var Utils = __importStar(require("./utils"));
var Button = Buttons.Button;
var Wrapper = Form.Wrapper, Input = Form.Input;
var useStyles = LibUtils.makeStyles(function (theme) { return ({
    indicatorContainer: {
        marginTop: theme.spacing(3)
    },
    buttonContainer: {
        marginTop: theme.spacing(4)
    }
}); });
exports.PasswordUI = function (_a) {
    var update = _a.update;
    var _b = react_1.useState(''), oldPassword = _b[0], setOldPassword = _b[1];
    var _c = react_1.useState(''), newPassword = _c[0], setNewPassword = _c[1];
    var _d = react_1.useState(''), newPasswordConfirmation = _d[0], setNewPasswordConfirmation = _d[1];
    var _e = react_1.useState(false), isLoading = _e[0], setLoading = _e[1];
    var _f = react_1.useState(undefined), errors = _f[0], setErrors = _f[1];
    var enqueueSnackbar = LibUtils.useSnackbar().enqueueSnackbar;
    var classes = useStyles();
    var handleFormSubmit = function (evt) {
        evt.preventDefault();
        var errors = {};
        if (!oldPassword) {
            errors.oldPassword = ['Your current password is required'];
        }
        if (!newPassword) {
            errors.newPassword = ['New password is required'];
        }
        if (!newPasswordConfirmation) {
            errors.newPasswordConfirmation = [
                'Confirmation of new password is required'
            ];
        }
        if (errors.oldPassword ||
            errors.newPassword ||
            errors.newPasswordConfirmation) {
            setErrors(errors);
            return;
        }
        if (newPassword !== newPasswordConfirmation) {
            setErrors({ newPassword: ['Passwords do not match'] });
            return;
        }
        setLoading(true);
        setErrors(undefined);
        update(oldPassword, newPassword)
            .then(function (x) {
            LibUtils.confirmMessage(enqueueSnackbar, 'Password successfully updated', 'success');
            setOldPassword('');
            setNewPassword('');
            setNewPasswordConfirmation('');
        })["catch"](function (err) {
            var msg = typeof err === 'string'
                ? err
                : err.message
                    ? err.message
                    : 'An error occured while trying to update your password';
            LibUtils.confirmMessage(enqueueSnackbar, msg, 'error');
        })["finally"](function () {
            setLoading(false);
        });
    };
    var strength = Utils.checkpassword(newPassword);
    return (react_1["default"].createElement("form", { onSubmit: handleFormSubmit },
        react_1["default"].createElement(Wrapper, { name: "oldPassword", label: "Current Password", errors: errors },
            react_1["default"].createElement(Input, { disabled: isLoading, onChange: function (v) { return setOldPassword(v.value); }, name: "oldPassword", type: "password", data: { oldPassword: oldPassword } })),
        react_1["default"].createElement(Wrapper, { name: "newPassword", label: "New Password", errors: errors },
            react_1["default"].createElement(Input, { disabled: isLoading, onChange: function (v) { return setNewPassword(v.value); }, name: "newPassword", type: "password", data: { newPassword: newPassword } })),
        react_1["default"].createElement(Wrapper, { name: "newPasswordConfirmation", label: "Repeat Password", errors: errors },
            react_1["default"].createElement(Input, { disabled: isLoading, onChange: function (v) { return setNewPasswordConfirmation(v.value); }, name: "newPasswordConfirmation", type: "password", data: { newPasswordConfirmation: newPasswordConfirmation } })),
        newPassword.length > 0 && (react_1["default"].createElement("div", { className: classes.indicatorContainer, "data-testid": "strength-indicator" },
            react_1["default"].createElement(core_1.Typography, null, "Strength:"),
            react_1["default"].createElement(core_1.LinearProgress, { variant: "determinate", color: strength > 2 ? 'primary' : 'secondary', value: strength * 25 }))),
        react_1["default"].createElement("div", { className: classes.buttonContainer },
            react_1["default"].createElement(Button, { disabled: isLoading, color: "primary", type: "submit", label: "Update" }))));
};
exports["default"] = exports.PasswordUI;
